import React, {useEffect} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import {connect} from 'react-redux'
import contractorImport from 'libs/contractorImport'
import ContractorService from "../../../services/ContractorService";
import Loading from "../../Loading";

const style = theme => ({
    root: {},
    dialog: {
        padding: 0
    },
    iframe: {
        border: "unset",
        width: "100%",
        height: "65vh"
    }
})

function AddContactor(
    {
        classes,
        onClose = () => {
        },
		addContractorsTab = ()=> {},
        demandId,
        onePlaceContractor
    }) {


    useEffect(() => {
        ContractorService.getOnePlace(demandId);
        return () => ContractorService.clearResources(ContractorService.CONTRACTOR_ONE_PLACE_ID);
    }, [demandId])


    return (
        <>
            <Dialog
                title={Tr('add_contractor')}
                open={true}
                maxWidth='lg'
                contentClassName={classes.dialog}
                onClose={onClose}
            >
                {!onePlaceContractor ?
                    <Loading/>
                    :
                    <iframe src={onePlaceContractor.url} title="Contactors" className={classes.iframe}></iframe>}
            </Dialog>
            {contractorImport(demandId, addContractorsTab, onClose)}
        </>
    )
}

AddContactor.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    onePlaceContractor: state.resources.onePlaceContractor,
}), {})(withStyles(style)(AddContactor));